export default {
  features: {
    applicationChangeStatusToDelivery: {
      button: 'Перекинуть на доставку',
      desc: 'При осуществлении доставки товара с вашей стороны',
    },
  },
};
